import Navbar from "../Components/Navbar";
// import BioGlimmerLOGO from "../Components/BioGlimmer LOGO.svg"

export default function Subpage() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        console.log(elementId)
    }

    // For accordion type of click and scroll
    window.onload = function () {
        const LeftId = ['Accordion-Level-2', 'Accordion-Level-2-1'];
        const RightId = ["Level-2", "Level-2-1"]
        for (let i = 0; i < LeftId.length; i++) {
            document.getElementById(LeftId[i]).addEventListener('click', () => {
                handleClick(RightId[i])
            })
        }
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div
                className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#application-sidebar-1" aria-controls="application-sidebar-1"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap" aria-label="Breadcrumb">
                        <li className="flex items-center text-sm text-gray-800">
                            Category-1
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate"
                            aria-current="page">
                            Category-2
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="application-sidebar-1"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-96 bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold"
                             aria-label="Brand">Subpage Title
                        </div>
                    </div>

                    <nav className="hs-accordion-group p-6 w-full flex flex-col flex-wrap"
                         data-hs-accordion-always-open>
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Level-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-2.5 bg-gradient-to-r from-blue-50 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                     href="#">
                                    <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24"
                                         height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                        <polyline points="9 22 9 12 15 12 15 22"/>
                                    </svg>
                                    Level-1
                                </div>
                            </li>

                            <li className="hs-accordion" id="1-users-accordion">
                                <div id="Accordion-Level-2"
                                     className="cursor-pointer hs-accordion-toggle w-full text-start flex items-center gap-x-3.5 py-2 px-2.5 hs-accordion-active:bg-gradient-to-r hs-accordion-active:from-blue-50 hs-accordion-active:hover:bg-transparent text-sm text-slate-700 rounded-lg hover:bg-gray-100">
                                    <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24"
                                         height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                                        <circle cx="9" cy="7" r="4"/>
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                    </svg>
                                    Level-2
                                    <svg className="hs-accordion-active:block ms-auto hidden size-4"
                                         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round">
                                        <path d="m18 15-6-6-6 6"/>
                                    </svg>

                                    <svg className="hs-accordion-active:hidden ms-auto block size-4"
                                         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round">
                                        <path d="m6 9 6 6 6-6"/>
                                    </svg>
                                </div>

                                <div id="1-users-accordion-sub"
                                     className="hs-accordion-content w-full overflow-hidden transition-[height] duration-300 hidden">
                                    <ul className="hs-accordion-group ps-3 pt-2" data-hs-accordion-always-open>
                                        <li className="hs-accordion" id="1-users-accordion-sub-1">
                                            <div id="Accordion-Level-2-1" type="button"
                                                 className="cursor-pointer hs-accordion-toggle w-full text-start flex items-center gap-x-3.5 py-2 px-2.5 hs-accordion-active:bg-gradient-to-r hs-accordion-active:from-blue-50 hs-accordion-active:hover:bg-transparent text-sm text-slate-700 rounded-lg hover:bg-gray-100">
                                                Level-2-1

                                                <svg className="hs-accordion-active:block ms-auto hidden size-4"
                                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="m18 15-6-6-6 6"/>
                                                </svg>

                                                <svg className="hs-accordion-active:hidden ms-auto block size-4"
                                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="m6 9 6 6 6-6"/>
                                                </svg>
                                            </div>

                                            <div id="1-users-accordion-sub-1-child"
                                                 className="hs-accordion-content w-full overflow-hidden transition-[height] duration-300 hidden">
                                                <ul className="pt-2 ps-2">
                                                    <li onClick={() => handleClick("Level-2-1-1")}>
                                                        <div
                                                            className="cursor-pointer flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                            href="#">
                                                            Level-2-1-1
                                                        </div>
                                                    </li>
                                                    <li onClick={() => handleClick("Level-2-1-2")}>
                                                        <div
                                                            className="cursor-pointer flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                            href="#">
                                                            Level-2-1-2
                                                        </div>
                                                    </li>
                                                    <li onClick={() => handleClick("Level-2-1-3")}>
                                                        <div
                                                            className="cursor-pointer flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                            href="#">
                                                            Level-2-1-3
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li className="hs-accordion" id="1-users-accordion-sub-2">
                                            <button type="button"
                                                    className="hs-accordion-toggle w-full text-start flex items-center gap-x-3.5 py-2 px-2.5 hs-accordion-active:bg-gradient-to-r hs-accordion-active:from-blue-50 hs-accordion-active:hover:bg-transparent text-sm text-slate-700 rounded-lg hover:bg-gray-100">
                                                Level-2-2

                                                <svg className="hs-accordion-active:block ms-auto hidden size-4"
                                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="m18 15-6-6-6 6"/>
                                                </svg>

                                                <svg className="hs-accordion-active:hidden ms-auto block size-4"
                                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="m6 9 6 6 6-6"/>
                                                </svg>
                                            </button>

                                            <div id="1-users-accordion-sub-2-child"
                                                 className="hs-accordion-content w-full overflow-hidden transition-[height] duration-300 hidden ps-2">
                                                <ul className="pt-2 ps-2">
                                                    <li>
                                                        <div
                                                            className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                            href="#">
                                                            Level-2-2-1
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div
                                                            className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                            href="#">
                                                            Level-2-2-2
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div
                                                            className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                            href="#">
                                                            Level-2-2-3
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="hs-accordion" id="1-account-accordion">
                                <button type="button"
                                        className="hs-accordion-toggle w-full text-start flex items-center gap-x-3.5 py-2 px-2.5 hs-accordion-active:bg-gradient-to-r hs-accordion-active:from-blue-50 hs-accordion-active:hover:bg-transparent text-sm text-slate-700 rounded-lg hover:bg-gray-100">
                                    <svg className="flex-shrink-0 mt-0.5 size-4" xmlns="http://www.w3.org/2000/svg"
                                         width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="18" cy="15" r="3"/>
                                        <circle cx="9" cy="7" r="4"/>
                                        <path d="M10 15H6a4 4 0 0 0-4 4v2"/>
                                        <path d="m21.7 16.4-.9-.3"/>
                                        <path d="m15.2 13.9-.9-.3"/>
                                        <path d="m16.6 18.7.3-.9"/>
                                        <path d="m19.1 12.2.3-.9"/>
                                        <path d="m19.6 18.7-.4-1"/>
                                        <path d="m16.8 12.3-.4-1"/>
                                        <path d="m14.3 16.6 1-.4"/>
                                        <path d="m20.7 13.8 1-.4"/>
                                    </svg>
                                    Level-3

                                    <svg className="hs-accordion-active:block ms-auto hidden size-4"
                                         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round">
                                        <path d="m18 15-6-6-6 6"/>
                                    </svg>

                                    <svg className="hs-accordion-active:hidden ms-auto block size-4"
                                         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round">
                                        <path d="m6 9 6 6 6-6"/>
                                    </svg>
                                </button>

                                <div id="1-account-accordion-sub"
                                     className="hs-accordion-content w-full overflow-hidden transition-[height] duration-300 hidden">
                                    <ul className="pt-2 ps-2">
                                        <li>
                                            <div
                                                className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                href="#">
                                                Level-3-1
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                href="#">
                                                Level-3-2
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                href="#">
                                                Level-3-3
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="hs-accordion" id="1-projects-accordion">
                                <button type="button"
                                        className="hs-accordion-toggle w-full text-start flex items-center gap-x-3.5 py-2 px-2.5 hs-accordion-active:bg-gradient-to-r hs-accordion-active:from-blue-50 hs-accordion-active:hover:bg-transparent text-sm text-slate-700 rounded-lg hover:bg-gray-100">
                                    <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24"
                                         height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect width="20" height="14" x="2" y="7" rx="2" ry="2"/>
                                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
                                    </svg>
                                    Level-4

                                    <svg className="hs-accordion-active:block ms-auto hidden size-4"
                                         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round">
                                        <path d="m18 15-6-6-6 6"/>
                                    </svg>

                                    <svg className="hs-accordion-active:hidden ms-auto block size-4"
                                         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round">
                                        <path d="m6 9 6 6 6-6"/>
                                    </svg>
                                </button>

                                <div id="1-projects-accordion-sub"
                                     className="hs-accordion-content w-full overflow-hidden transition-[height] duration-300 hidden">
                                    <ul className="pt-2 ps-2">
                                        <li>
                                            <div
                                                className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                href="#">
                                                Level-4-1
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                href="#">
                                                Level-4-2
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                                href="#">
                                                Level-4-3
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <div
                                    className="w-full flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                    href="#">
                                    <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24"
                                         height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/>
                                        <line x1="16" x2="16" y1="2" y2="6"/>
                                        <line x1="8" x2="8" y1="2" y2="6"/>
                                        <line x1="3" x2="21" y1="10" y2="10"/>
                                        <path d="M8 14h.01"/>
                                        <path d="M12 14h.01"/>
                                        <path d="M16 14h.01"/>
                                        <path d="M8 18h.01"/>
                                        <path d="M12 18h.01"/>
                                        <path d="M16 18h.01"/>
                                    </svg>
                                    Level-5
                                </div>
                            </li>
                            <li>
                                <div
                                    className="w-full flex items-center gap-x-3.5 py-2 px-2.5 text-sm text-slate-700 rounded-lg hover:bg-gray-100"
                                    href="#">
                                    <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24"
                                         height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                                        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                                    </svg>
                                    Level-6
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-8 lg:ps-10" id="scrollspy-subpage">
                    <div>
                        <div id="Level-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Level-1 Content
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 bg-gradient-to-r from-blue-50 px-8 py-6 rounded-2xl leading-relaxed">
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                        </div>
                    </div>
                    <div>
                        <div id="Level-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Level-2 Content
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 bg-gradient-to-r from-blue-50 px-8 py-6 rounded-2xl leading-relaxed">
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                        </div>
                    </div>
                    <div>
                        <div id="Level-2-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Level-2-1 Content
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 bg-gradient-to-r from-blue-50 px-8 py-6 rounded-2xl leading-relaxed">
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                        </div>
                    </div>
                    <div>
                        <div id="Level-2-1-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Level-2-1-1 Content
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 bg-gradient-to-r from-blue-50 px-8 py-6 rounded-2xl leading-relaxed">
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                        </div>
                    </div>
                    <div>
                        <div id="Level-2-1-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Level-2-1-2 Content
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 bg-gradient-to-r from-blue-50 px-8 py-6 rounded-2xl leading-relaxed">
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                        </div>
                    </div>
                    <div>
                        <div id="Level-2-1-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Level-2-1-3 Content
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 bg-gradient-to-r from-blue-50 px-8 py-6 rounded-2xl leading-relaxed">
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                            Text for different sections Text for different sections Text for different sections
                        </div>
                    </div>
                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <div>
                <footer className="w-full max-w-[85rem] py-6 px-4 sm:px-6 lg:px-8 mx-auto border-t border-slate-900/10">
                    <div className="text-center">
                        {/*<img className="w-80 h-80 mx-auto" src={BioGlimmerLOGO} alt=""/>*/}
                        <div className="mt-3 flex-none text-xl font-semibold text-black">
                            BioGlimmer @ iGEM
                        </div>
                        <div className="mt-3 text-gray-600">
                            <span>The source code is available at </span>
                            <span className="hover:text-blue-700 transition-all duration-300">
                                <a
                                    href="https://gitlab.igem.org/2024/stockholm"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dec-n bold color-b"
                                >
                                    https://gitlab.igem.org/2024/stockholm
                                </a>
                            </span>
                        </div>
                        <div className="mt-3 text-gray-600">
                            <span>This website is licensed under </span>
                            <span className="hover:text-blue-700 transition-all duration-300">
                                <a
                                    href="https://creativecommons.org/licenses/by/4.0/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dec-n bold color-b"
                                >
                                    Creative Commons Attribution 4.0
                                </a>
                            </span>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    )
}